<template>
	<v-card outlined>
		<v-card-title>
			{{ $vuetify.lang.t("$vuetify.views.profile.profile") }}
		</v-card-title>
		<v-card-text>
			<div class="d-flex">
				<div class="mr-16">
					<div class="grey--text">
						{{
							$vuetify.lang.t(
								"$vuetify.views.profile.jobPosition"
							)
						}}
					</div>
					<div
						class="font-weight-bold grey--text text--darken-1 font-14"
					>
						{{ jobPosition || "-" }}
					</div>
				</div>

				<div class="ml-16">
					<div class="grey--text">Zespół</div>
					<div
						class="font-weight-bold grey--text text--darken-1"
					>
						{{ teamName || "-" }}
					</div>
					<div v-if="teamName" class="grey--text">
						<span>{{ workersCount }}</span> pracowników
					</div>
				</div>
			</div>
		</v-card-text>
	</v-card>
</template>

<script>
export default {
	props: {
		jobPosition: {
			type: String,
		},
		teamName: {
			type: String,
		},
		workersCount: {
			type: Number,
		},
	},
};
</script>

<style scoped>
.title-font {
	font-size: 16px;
}
</style>
